export default __webpack_public_path__ + "0efa538a09b932ee19ebba5e6f7f1239.gif";